import { ShowOpenStatus } from "@portal/BaseComponents/Table/Components/OpenStatus/OpenStatus";
import { DisputeList } from "@portal/types/entities/dispute";
import { CellRenderProps } from "@sinecycle/growcomponents";

function OpenStatus(props: Partial<CellRenderProps<DisputeList>>) {
  return props.data?.status === "OPEN" ? (
    <ShowOpenStatus date={props.data?.created_at ?? ""} />
  ) : (
    "-"
  );
}

export { OpenStatus };
